<template>
	<aside class="flex flex-col h-full py-2 px-4 bg-white dark:bg-gray-800 dark:text-gray-200 shadow-md" id="sidebar_menu">
	  <div class="flex-grow">

		<div class="flex items-center justify-center">
			<UAvatar
				src="/favicons/web-app-manifest-192x192.png"
				size="2xl"
				class="hidden lg:block"
			/>
		</div>

		<div class="flex items-center justify-between lg:p-3">

			<div class="flex items-center space-x-2">
				<!-- <UIcon name="i-material-icons-menu" class="text-2xl" /> -->
				<UAvatar
					src="/favicons/web-app-manifest-192x192.png"
					size="xs"
					class="block lg:hidden"
				/>
				<!-- ЗДЕСЬ ПРИМЕР ИСПОЛЬЗОВАНИЯ В ШАБЛОНЕ -->
				<div class="text-lg font-bold">{{ useRuntimeConfig().public?.project_title }}</div>
			</div>

			<div class="flex items-center space-x-2">

				<ColorScheme>
					<UButton
						v-if="$colorMode.preference === 'light'"
						icon="i-heroicons-moon"
						size="sm"
						color="primary"
						square
						variant="ghost"
						@click="$colorMode.preference = 'dark'"
					/>
					<UButton
						v-else
						icon="i-heroicons-sun"
						size="sm"
						color="primary"
						square
						variant="ghost"
						@click="$colorMode.preference = 'light'"
					/>

				</ColorScheme>

				<UButton
					:icon="is_mobile_menu_open ? 'i-material-symbols-close-rounded' : 'i-material-symbols-menu-rounded'"
					color="gray"
					square
					variant="ghost"
					size="xl"
					@click="is_mobile_menu_open = !is_mobile_menu_open"
					class="lg:hidden"
				/>
			</div>
		</div>

		<!-- <div>breakpoints.smaller('lg') {{ breakpoints.smaller('lg') }}</div> -->

		<div class="space-y-3 pt-3 lg:border-t border-gray-100 dark:border-gray-700" :class="{ 'hidden': !is_mobile_menu_open && (breakpoints.smaller('lg').value || $device.isMobile) }">

			<div class="my-3 space-y-3" >
				<!-- ТУТ КАК В АТРИБУТЕ ЭТО РАБОТАЕТ :label-->
				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/"
					:label="$t('glavnaya')"
					:variant="($route.path === '/') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>
				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/users"
					icon="i-flowbite-users-solid"
					:label="$t('polzovately')"
					:variant="($route.path === '/users') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>

				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/txs"
					icon="i-heroicons-list-bullet"
					:label="$t('transaktsii')"
					:variant="($route.path === '/txs') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>

				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/cards"
					icon="i-heroicons:credit-card-solid"
					:label="$t('cards')"
					:variant="($route.path === '/cards') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>

				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/cards_issue_orders"
					icon="i-mdi-credit-card-clock"
					:label="$t('cards_issue_orders')"
					:variant="($route.path === '/cards_issue_orders') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>
				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/cards_topup_orders"
					icon="i-mdi-credit-card-plus"
					:label="$t('cards_topup_orders')"
					:variant="($route.path === '/cards_topup_orders') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>

				<UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin') || auth_store.user?.roles_slugs?.includes('fin_reports')"
					to="/main_report"
					icon="i-heroicons-document-chart-bar"
					:label="$t('main_report')"
					:variant="($route.path === '/main_report') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/>

				<!-- <UButton
					v-if="auth_store.user?.roles_slugs?.includes('admin')"
					to="/master-account"
					icon="i-material-symbols-account-balance-wallet"
					:label="$t('master_account')"
					:variant="($route.path === '/master-account') ? 'solid' : 'soft'"
					block
					@click="is_mobile_menu_open = false"
				/> -->

			</div>

			<UAccordion :items="menu" multiple v-if="menu.length" >
				<template #item="{ item }">
					<nav class="space-y-3 border-l border-gray-200 dark:border-gray-800 ml-2.5">
					<div class="space-y-1.5 border-gray-200 dark:border-gray-800">
						<ULink
							v-for="link in item.links"
							:to="link.to"
							class="flex items-center gap-1.5 group border-l -ml-px pl-4 submenu-link"
							:key="link.to"
							@click="is_mobile_menu_open = false"
						>
							{{ link.label }}
						</ULink>
					</div>
					</nav>
				</template>
			</UAccordion>

		</div>

	</div>

	<!-- Выбор языка -->
	<div class="flex items-center rounded my-6" :class="{ 'hidden': !is_mobile_menu_open && (breakpoints.smaller('lg').value || $device.isMobile) }">

		<UButton :color="locale_item.code == locale ? 'primary':'white'" v-for="locale_item in locales" @click="update_user_language(locale_item.code)" :key="locale_item.code" variant="soft">
			<div class="flex items-center gap-2">
				<img v-if="locale_item.code == 'en'" :src="`https://flagcdn.com/us.svg`" alt="flag" class="w-6 h-6" />
				<img v-else :src="`https://flagcdn.com/${locale_item.code}.svg`" alt="flag" class="w-6 h-6" />
				<span class="text-gray-700">{{ locale_item.code.toLocaleUpperCase() }}</span>
			</div>
		</UButton>

	</div>

	<!-- Баланс мастер-счета (только в мобильной версии) -->
	<!-- <div :class="{ 'hidden': !is_mobile_menu_open && (breakpoints.smaller('lg').value || $device.isMobile) }">
		<ClientOnly>
			<MasterAccountBalance />
		</ClientOnly>
	</div> -->

	<div class="border-t border-gray-200 dark:border-gray-700 mt-4 pt-4" :class="{ 'hidden': !is_mobile_menu_open && (breakpoints.smaller('lg').value || $device.isMobile) }">

		<div v-if="user">
			<UDropdown 
				:items="[
					[{
						label: $t('profile'),
						to: '/profile',
						icon: 'i-heroicons-user-circle'
					},
					{
						label: $t('logout'),
						icon: 'i-ic-baseline-logout',
						click: auth_store.logout,
					}]
				]"
				:ui="{
				base: 'w-full md:w-auto', 
				}"
			>
				<UBadge color="gray">
					<UButton
					variant="link"
					color="gray"
					class="w-[200px] "
					:label="user.email"
					size="sm"
					truncate
					@click="is_mobile_menu_open = false" 
					/>
				</UBadge>
			</UDropdown>
		</div>

		<div v-else>
			<UButton
			class="w-full mt-2"
			icon="i-ic-baseline-login"
			:label="$t('voyty')"
			@click="auth_store.auth_modal_show()"
			/>
		</div>

	</div>


</aside>
</template>

<script setup lang="ts">

import { ref } from 'vue';

const auth_store = useAuthStore()

const { is_auth_modal_visible, user } = storeToRefs(auth_store)

const api = useApi();

const is_mobile_menu_open = ref(false);

// !!! ВОТ ЭТО ИСПОЛЬЗУЕТСЯ ДЛЯ ПЕРЕВОДОВ, НУЖНО ДОБАВИТЬ ВЕЗДЕ ГДЕ БУДУТ ЛОКАЛИЗОВАННЫЕ ТЕКСТЫ !!!
const { locales, setLocale, locale, t } = useI18n()

type LocaleCode = 'en' | 'ru';

async function update_user_language(code: LocaleCode) {

	if (auth_store?.user?.language_code == code) return;

	// await setLocale(code);
	// useDayjs().locale(code)

	try {
		const response_data = await api.post<{ success: boolean }>('/api/admin_users/update_language', {
			language_code: code,
		});

		if (response_data?.success) {
			await setLocale(code);
			useDayjs().locale(code)

		} else {
			console.error('Error updating user language:', response_data);

			useToast().add({
				title: t('error'),
				color: 'red',
			});
		}

	} catch (e) {
		console.error('Error updating user language:', e);

		useToast().add({
			title: t('error'),
			color: 'red',
		});
	}


}

import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(
	breakpointsTailwind,
)

// Пример меню
const menu = computed(() => {
	let result = []

	let available_menus = []

	if (auth_store.user?.roles_slugs?.includes('admin')) {

		available_menus.push('admin')
		available_menus.push('fin')

	}

	// Check for financial roles
	if (['fin_reports', 'fin_expenses_read', 'fin_expenses_write'].some(role => auth_store.user?.roles_slugs?.includes(role))) {
		available_menus.push('fin')
	}

	available_menus = [...new Set(available_menus)]



	if (available_menus.includes('admin')) {
		result.push({
			// !!! ВОТ ТАК В JS\TS КОДЕ РЕАЛИЗУЮТСЯ ПЕРЕВОДЫ !!!
			label: t('upravlenie-dostupom'),
			links: [
				{ label: t('users_admin'), to: '/admin/users' },
				{ label: t('roles_admin'), to: '/admin/roles' },
			],
		});
	}

	// if (available_menus.includes('fin')) {
	// 	result.push({
	// 		label: 'Финансы',
	// 		children: [
	// 			{ label: 'Управление расходами', to: '/fin/expenses' },
	// 		],
	// 	});
	// }

	console.log(result)

	return result
});

// const { screen_width: width } = useWindowSize()




// let pg_menu = {
// 	label: 'Postgres',
// 	children: [],
// };

// if (pg_tables?.data?.value?.items) {

// 	for (const table of pg_tables?.data?.value?.items) {
// 		console.log(table);
// 		pg_menu.children.push({
// 			label: table,
// 			to: `/cc/datasources/pg?table=${table}`,
// 		});
// 	}

// }

// menu.value.push(pg_menu);

// menu.value.push({
// 	label: 'Управление доступом',
// 	children: [
// 		{ label: 'Пользователи (Админка)', to: '/admin/users' },
// 		{ label: 'Роли (Админка)', to: '/admin/roles' },
// 	],
// });

// menu.value.push({
// 	label: 'Финансы',
// 	children: [
// 		{ label: 'Управление расходами', to: '/fin/expenses' },
// 	],
// });

</script>

<style scoped>
.submenu {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.submenu li {
	margin: 0.5rem 0;
}

.submenu-link {
	text-decoration: none;
	color: var(--color-text-secondary);
	font-size: 0.9rem;
}

.submenu-link:hover {
	color: var(--color-primary);
}
</style>
